import { arrayOf, object, oneOfType, shape, string } from 'prop-types';
function getFlatText(str) {
    return str
        .toString()
        .toLowerCase()
        .replace(/[^\w]+/g, ' ')
        .trim();
}
function getConfiguredCrumb(currentLocation, rawCrumb, baseUrl) {
    let to = rawCrumb.url ||
        (rawCrumb.omitInPath && currentLocation.replace(rawCrumb.omitInPath, '')) ||
        (rawCrumb.keepInPath &&
            currentLocation.match(rawCrumb.keepInPath).join('')) ||
        '';
    if (to.endsWith('/')) {
        to = to.slice(0, to.length - 1);
    }
    const title = rawCrumb.title || getFlatText(to);
    return { to: baseUrl ? `${baseUrl}${to}` : to, title };
}
const BASIC_PROP_TYPES = {
    crumbs: arrayOf(shape({
        title: string,
        url: string,
        omitInPath: oneOfType([string, object]),
        keepInPath: object,
    })).isRequired,
    classes: shape({
        wrapper: string,
        item: string,
        link: string,
        current: string,
    }),
    baseUrl: string,
};
const BASIC_DEFAULT_PROPS = {
    classes: {},
    baseUrl: '',
};
export { BASIC_DEFAULT_PROPS, BASIC_PROP_TYPES, getConfiguredCrumb };
